import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Container,
  Flex,
  Heading,
  Icon,
  Text,
  Spinner,
} from '@chakra-ui/react';
import { CloseIcon, StarIcon } from '@chakra-ui/icons';
import { generate } from 'shortid';
import axios from 'axios';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';
import { animated as a, useSpring } from 'react-spring';
import PropTypes from 'prop-types';

import { graphql } from 'gatsby';
import { useForm } from 'react-hook-form';
import GoogleG from '../assets/Google__G__Logo.svg';
import { useFormValue } from '../context';
import { SEO } from '../components/_index';

const seoContent = {
  title: "Get your offer today - [We're #1 For A Reason]",
  description:
    'We Buy Houses in . We are a local home buying company in and we pay cash for houses. "Sell my house without cleaning or repairing or paying closing costs!"',
};

const ReviewCallout = ({ data }) => {
  const image = getImage(data);
  const review = {
    rating: 5,
    author_name: 'Ben Buchman',
    text: 'I have done some contracting work for Eugene and I can see why he has such great reviews. He makes sure everyone around him is comfortable and doesn’t flinch if you ask for help. He is a people person, pays in time and has extremely competitive pricing for his homes. Eugene is as straight as an arrow when it comes to his goals and his understanding and has the most experience when it comes to buying your home.',
  };
  return (
    <Container
      maxW="container.lg"
      py={6}
    >
      <Box
        rounded="md"
        p={5}
        backgroundColor="white"
        boxShadow="xl"
        display="flex"
        flexDirection={{ base: 'column-reverse', md: 'row' }}
        alignItems="center"
      >
        <Box
          flexBasis={{ base: '100%', md: '30%' }}
          display="flex"
          flexDir="column"
          justifyContent="flex-end"
        >
          <Box
            display="flex"
            flexDir="row"
            width="200px"
            flexWrap="wrap"
            alignItems="center"
            justifyContent="space-around"
          >
            <Box width="200px">
              <GatsbyImage image={image} />
            </Box>
          </Box>
          {/* <Avatar
            size="2xl"
            name={`Google profile of ${review.author_name}`}
            src={review.profile_photo_url}
          />{' '} */}
        </Box>
        <Box flexBasis={{ base: '100%', md: '70%' }}>
          <Box
            mb={3}
            display="flex"
            alignItems="center"
          >
            <Box mr={2}>
              <GoogleG />
            </Box>
            {Array.from({ length: review.rating }, () => 0).map((j) => (
              <Icon
                key={generate()}
                as={StarIcon}
                boxSize={6}
                color="yellow.300"
              />
            ))}
          </Box>
          <Text
            mb={4}
            fontSize="xl"
            as="em"
            noOfLines="5"
          >
            {review.text}
          </Text>
          <Heading
            as="h6"
            variant="sec"
            size="md"
          >
            -
            {' '}
            {review.author_name}
          </Heading>
        </Box>
      </Box>
    </Container>
  );
};

const GetOfferPage = ({ data, location }) => {
  const { formStore, setFormStore } = useFormValue();
  const [waiting, setWaiting] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    type: 'warning',
    message: '',
  });

  // form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: formStore,
    reValidateMode: 'onChange',
  });

  useEffect(() => {
    console.log('formstore', formStore);
  }, [formStore]);

  const AlertMessage = ({ message }) => (
    <Alert
      mt={6}
      borderRadius="md"
      status={message.type}
    >
      <Flex justifyContent="space-between">
        <AlertIcon />
        <AlertTitle mr={2} />
        <AlertDescription color="gray.800">{message.message}</AlertDescription>
        <CloseIcon
          color="gray.800"
          onClick={() => setAlertMessage({ type: 'warning', message: '' })}
          ml={4}
        />
      </Flex>
    </Alert>
  );

  const onSubmit = async (leadData) => {
    setWaiting(true);
    console.log(typeof leadData);
    const results = await axios
      .post(
        'https://hooks.zapier.com/hooks/catch/6894175/b2jx6m3/',
        JSON.stringify(leadData),
      )
      .then((res) => {
        console.log('status', res.status);
        setWaiting(false);
        if (res.status === 200) {
          setAlertMessage({
            type: 'success',
            message: 'Thank you, we will be in touch you shortly.',
          });
          return 200;
        }
      })
      .catch((err) => {
        setWaiting(false);
        console.log('status', err.status);
        if (err.status === 401) {
          setAlertMessage({
            type: 'warning',
            message:
              'We already have your info. If you think we missed you, ping us on slack',
          });
          return 401;
        }
        setAlertMessage({
          type: 'error',
          message:
            "Something went wrong. Please try again and if that doesn't work ping us on slack",
        });
      });
    return results;
  };

  useEffect(() => {
    if (location.hash) {
      const timer = setTimeout(() => {
        const scrollPositionInit = window.scrollY;
        const offSet = window.innerHeight / 4;
        const test = scrollPositionInit - offSet;
        console.log('test', test);
        window.scrollTo({
          top: test,
          left: 0,
        });
      }, 900);
      return () => clearTimeout(timer);
    }

    // Logs `HTMLInputElement`
  }, []);

  return (
    <Box position="relative">
      <SEO
        location={location}
        title={seoContent.title}
        description={seoContent.description}
      />
      <main>
        <Box
          py={20}
          zIndex="3"
        >
          <Container>
            <Heading
              as="h1"
              maxWidth="800px"
              size="3xl"
              lineHeight="base"
              mb={10}
            >
              Receive Your Free Offer Today!
            </Heading>
          </Container>

          <Box>
            <Container>
              <Heading
                as="h3"
                size="lg"
                variant="sec"
                mb={5}
                mt={10}
              >
                We Buy Houses in the Bay Area in any condition.
                {' '}
                <span className="highlight">
                  No realtors, no fees, no commission
                </span>
                {' '}
                and best of all,
                {' '}
                <span className="highlight">
                  no repairs or cleaning&nbsp;necessary
                </span>
                .
              </Heading>
            </Container>
            <Container>
              <form
                id="get-offer-form"
                className="contact start-conversation"
                onSubmit={handleSubmit(onSubmit)}
              >
                <Box
                  display="flex"
                  flexDirection={{ base: 'column' }}
                  className="add-name"
                >
                  <Box my={6}>
                    <div className="add-email input-container">
                      <Heading
                        as="h5"
                        size="md"
                        mb={4}
                        lineHeight="base"
                        variant="sec"
                      >
                        What is your Address?
                      </Heading>
                      <label htmlFor="address">Address</label>
                      <input
                        className={errors.address ? 'error' : ''}
                        type="address"
                        id="address"
                        defaultValue={formStore.address}
                        placeholder="Enter Address"
                        {...register('address', {
                          required: true,
                          maxLength: 80,
                        })}
                      />

                      {errors.address && errors.address.type === 'required' && (
                        <Text
                          fontSize="sm"
                          color="red.400"
                          backgroundColor="transparent"
                          mr={4}
                        >
                          Address is required
                        </Text>
                      )}
                    </div>
                  </Box>
                  <Heading
                    as="h5"
                    size="md"
                    mb={4}
                    variant="sec"
                    lineHeight="base"
                  >
                    What is your name?
                  </Heading>

                  <Flex
                    justifyContent="space-between"
                    flexWrap="wrap"
                    flexDirection={{ base: 'column', md: 'row' }}
                  >
                    <Box
                      flexGrow="1"
                      className="input-name"
                      mr={{ base: '0', md: '4' }}
                    >
                      <label htmlFor="firstname">First Name</label>
                      <input
                        id="firstname"
                        type="text"
                        className={errors.firstname ? 'error' : ''}
                        placeholder="First Name"
                        defaultValue={formStore.firstname}
                        {...register('firstname', { required: true })}
                      />
                      {errors.firstname
                        && errors.firstname.type === 'required' && (
                          <Text
                            fontSize="sm"
                            color="red.400"
                            backgroundColor="transparent"
                            mr={4}
                          >
                            First name is required
                          </Text>
                      )}
                    </Box>

                    <Box
                      flexGrow="1"
                      className="input-name"
                    >
                      <label htmlFor="lastname">Last Name</label>
                      <input
                        id="lastname"
                        type="text"
                        defaultValue={formStore.lastname}
                        className={errors.lastname ? 'error' : ''}
                        placeholder="Last Name"
                        {...register('lastname', { required: true })}
                      />
                      {errors.lastname && errors.lastname.type === 'required' && (
                        <Text
                          fontSize="sm"
                          color="red.400"
                          backgroundColor="transparent"
                          mr={4}
                        >
                          Last name is required
                        </Text>
                      )}
                    </Box>
                  </Flex>
                </Box>

                <Box my={6}>
                  <div className="add-email input-container">
                    <Heading
                      as="h5"
                      size="md"
                      mb={4}
                      lineHeight="base"
                      defaultValue={formStore.email}
                      variant="sec"
                    >
                      What is your email?
                    </Heading>
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      id="email"
                      className={errors.email ? 'error' : ''}
                      placeholder="Enter Email"
                      {...register('email', {
                        required: true,
                        maxLength: 45,
                      })}
                    />
                    {errors.email && errors.email.type === 'required' && (
                      <Text
                        fontSize="sm"
                        color="red.400"
                        backgroundColor="transparent"
                        mr={4}
                      >
                        Email is required
                      </Text>
                    )}
                  </div>
                </Box>
                <Box my={6}>
                  <div className="add-email input-container">
                    <Heading
                      as="h5"
                      size="md"
                      mb={4}
                      lineHeight="base"
                      variant="sec"
                    >
                      What is your phone number?
                    </Heading>
                    <label htmlFor="phone">Phone</label>
                    <input
                      type="phone"
                      defaultValue={formStore.phone}
                      id="phone"
                      placeholder="Phone"
                      className={errors.phone ? 'error' : ''}
                      {...register('phone', {
                        required: false,
                        maxLength: 45,
                      })}
                    />
                    {errors.phone && errors.phone.type === 'required' && (
                      <Text
                        fontSize="sm"
                        color="red.400"
                        backgroundColor="transparent"
                        mr={4}
                      >
                        Phone number is required
                      </Text>
                    )}
                  </div>
                </Box>
                {waiting ? (
                  <div className="light btn-one">
                    <Spinner size="sm" />
                  </div>
                ) : (
                  <input
                    className="light btn-one"
                    type="submit"
                    value="Submit"
                  />
                )}
              </form>
              <Box minheight="50px">
                {alertMessage.message !== '' ? (
                  <AlertMessage
                    backgroundColor="transparent"
                    message={alertMessage}
                  />
                ) : undefined}
              </Box>
              <Heading
                as="h3"
                size="xl"
                mb={10}
                lineHeight="base"
              />
            </Container>
            <Container maxW="container.xl">
              <ReviewCallout data={data.bbbFancy} />
            </Container>
            {/* <Reviews /> */}
          </Box>
        </Box>
      </main>
    </Box>
  );
};

export default GetOfferPage;

GetOfferPage.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

GetOfferPage.defaultProps = {
  title: null,
  description: null,
};

export const query = graphql`
  query {
    site {
      siteMetadata {
        author
        baseUrl
        description
        image
        phone
        siteUrl
        title
        titleTemplate
        twitterUsername
      }
    }
    bbbFancy: file(relativePath: { eq: "fancy-bbb.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
  }
`;
